import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 获取路由
 *
 * @returns 路由定义
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'task/enroll/:taskId',
    getTitle: () => '报名',
    name: 'EnrollTask',
    component: lazy(() =>
      import('./pages/Enroll').then((m) => ({
        default: m.Enroll,
      }))
    ),
  },
]
